import { TopBar } from "./types";
import { TopBarSelectors } from "./selectors";
import { TxActions } from "src/redux/Tx/actions";
import { InventoryActions } from "src/redux/Inventory/actions";
import { AvailabilityActions } from "src/redux/Availability/actions";
import { DashboardActions } from "src/redux/Dashboard/actions";
import { Auth } from "src/redux/Auth/types";
import { VIEWS } from "./constants";

/**
 * Load data for the given view. Returns a promise that resolves when the
 * initial data fetch is complete so callers can gate APP_READY on it.
 */
const loadViewData = (dispatch, view) => {
    switch (view) {
        case VIEWS.TRANSACTIONS:
            return dispatch(TxActions.UpdateEntries());
        case VIEWS.INVENTORY:
            return dispatch(InventoryActions.GetTodayInventory());
        case VIEWS.AVAILABILITY:
            return dispatch(AvailabilityActions.GetTodayAvailability());
        case VIEWS.DASHBOARD:
            return dispatch(DashboardActions.FetchAll());
        default:
            return Promise.resolve();
    }
};

export const TopBarActions = {
    SetRole: (role) => {
        return async (dispatch, getState) => {
            dispatch({ type: Auth.APP_NOT_READY });

            dispatch({
                type: TopBar.SET_ROLE,
                role,
            });

            localStorage.setItem(TopBar.SET_ROLE, role);

            const currView = TopBarSelectors.View(getState());
            if (currView) {
                await loadViewData(dispatch, currView);
            }

            dispatch({ type: Auth.APP_READY });
        };
    },

    SetView: (view) => {
        return async (dispatch) => {
            dispatch({ type: Auth.APP_NOT_READY });

            dispatch({
                type: TopBar.SET_VIEW,
                view,
            });

            localStorage.setItem(TopBar.SET_VIEW, view);

            await loadViewData(dispatch, view);

            dispatch({ type: Auth.APP_READY });
        };
    },
};
